import { useCallback } from 'react';
import { useUpdateUserMutation } from '../store/api/user.api';
import { useDbUserId } from './useDbUserId';

export const useUserDataBlurHandler = ({ checkbox, userRefetch, setUserDataState }) => {
	const { dbUserId } = useDbUserId();
	const [updateUserData] = useUpdateUserMutation();

	const handleBlur = useCallback(
		async (fieldName, value) => {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (fieldName === 'email' && value.length > 0) {
				if (!emailRegex.test(value)) {
					alert('Неверный формат Email');
					setUserDataState(prev => ({
						...prev,
						[fieldName]: ''
					}));
					return;
				}
			}

			if (!checkbox) return;

			try {
				const updatedData = {
					id: dbUserId,
					[fieldName]: value,
				};
				await updateUserData(updatedData);
				if(userRefetch) userRefetch();
			} catch (error) {
				console.error('Error updating user data:', error);
			}
		},
		[checkbox, dbUserId, updateUserData, userRefetch, setUserDataState]
	);

	return { handleBlur };
};
